(function () {
  function getCookie(name) {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.startsWith(name + '=')) {
        return cookie.substring(name.length + 1);
      }
    }
    return '';
  }

  function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
    const R    = 6371;
    const dLat = deg2rad(lat2 - lat1);
    const dLon = deg2rad(lon2 - lon1);
    const a    =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c    = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return R * c;
  }
  function isGooglebot() {
    const userAgent = navigator.userAgent.toLowerCase();
    return userAgent.includes('googlebot');
}


  function populateStores(provinceToStores, province, storeId) {
    let stores = provinceToStores[province];
    const allStoresArray = Object.values(provinceToStores).flat();
    // console.log(allStoresArray,"allStoresArray")
    if (province !== '') {
      ageVerificationStore.parentElement.classList.remove('hidden');
    } else {
      ageVerificationStore.parentElement.classList.add('hidden');
    }

    ageVerificationStore.innerHTML = '';

    const defaultOption       = document.createElement('option');
    defaultOption.value       = '';
    defaultOption.textContent = 'Select Your Store';
    ageVerificationStore.appendChild(defaultOption);

    if (stores) {
       stores.sort((a, b) => {
        
        return a.distance - b.distance; // Sort by distance
    });


      const storeIds = [];
      allStores.innerHTML = '';  // Clears out old options before adding new ones

      allStoresArray.forEach(store => {
          const Alldata = `${store.address.city} - ${store.address.street1} ${store.distance ? '(' + store.distance.toFixed(0) + 'km)' : ''}`;
          const option = document.createElement('a');
          option.setAttribute('data-v', store.store_id);
          option.setAttribute('href', `/?sID=${store.store_id}`);
          option.textContent = Alldata;
          option.setAttribute('data-p', store.address.province);
          allStores.appendChild(option);
          storeIds.push(store.store_id);
      });
      stores.forEach(store => {
        const option       = document.createElement('option');
        option.value       = store.store_id;
        option.textContent = `${store.address.city} - ${store.address.street1} ${store.distance ? '(' + store.distance.toFixed(0) + 'km)' : ''}`;
        ageVerificationStore.appendChild(option);

        storeIds.push(store.store_id);
      });
      allStores.querySelectorAll('a').forEach((event) => {
      event.addEventListener('click', (event) => {
      event.preventDefault();
      const target = event.target;
        const store_Id = target.getAttribute('data-v');
        const province = target.getAttribute('data-p');

        const selectedStore = allStoresArray.find(store => store.store_id === store_Id);
        if (selectedStore) {
            const provinceSelect = document.getElementById('province-select');
            const storeSelect = document.getElementById('store-select');
            // Set the value to Alberta
            provinceSelect.value = province;
            storeSelect.value = store_Id
            // Trigger the change event to make sure any other change handlers are fired
            const event = new Event('change', { bubbles: true });
            provinceSelect.dispatchEvent(event);
            // Delay storeSelect to give provinceSelect change logic time to complete
          setTimeout(() => {
              storeSelect.value = store_Id;
              storeSelect.dispatchEvent(event);
          }, 50); // 50ms is usually enough, but you can tweak it

        }

      })  
      
    });
      if ((storeId === '' && stores.length > 0) || (stores[0].distance && !storeIds.includes(storeId))) {
        ageVerificationStore.value = stores[0].store_id;
        ageVerificationStore.dispatchEvent(new Event('change', {'bubbles': true}));
      } else if (storeIds.includes(storeId)) {
        ageVerificationStore.value = storeId;
        ageVerificationStore.dispatchEvent(new Event('change', {'bubbles': true}));
      }
    }
  }

  function deg2rad(deg) {
    return deg * (Math.PI / 180);
  }

  function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires     = 'expires=' + d.toUTCString();
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
  }

  let checkAgeVerified    = true;
  let checkAgePopupCookie = getCookie('age-verification');
  let storeId             = localStorage.getItem('global_store_id') ?? '';

  if (document.querySelectorAll('[data-popup-type="age-verification"]').length > 0 && (checkAgePopupCookie === '' || storeId === '') && document.querySelectorAll('.theme-modal-popup.design__mode').length === 0) {
    checkAgeVerified         = false;
    let ageVerificationPopup = document.querySelector('[data-popup-type="age-verification"]');
    
    document.querySelector('body').classList.add('overflow-hidden');
    if (!isGooglebot()) {
     document.querySelector('.theme-modal-popup__overlay').classList.add('active');
     ageVerificationPopup.classList.add('active');
    }
   
    setTimeout(function () {
      trapFocus(ageVerificationPopup);
    }, 1500);
  }

  if (checkAgeVerified === true && document.querySelectorAll('.theme-modal-popup.design__mode').length === 0) {
    let checkNewsletterPopupCookie = getCookie('newsletter-popup');
    let newsletterPopup            = document.querySelector('[data-popup-type="newsletter"]');
    if (checkNewsletterPopupCookie === '' && newsletterPopup) {
      let popupDelayTime = parseInt(newsletterPopup.dataset.popupDelaySeconds);
      setTimeout(function () {
        newsletterPopup.classList.add('active');
        document.querySelector('body').classList.add('overflow-hidden');
        document.querySelector('.theme-modal-popup__overlay').classList.add('active');
        setTimeout(function () {
          trapFocus(newsletterPopup);
        }, 500);
      }, popupDelayTime);
    }
  }

  let ageVerifiedButton         = document.querySelector('.age-varified__button');
  const legalAgeInput           = document.querySelectorAll('input[name="age-verification"]');
  const ageVerificationProvince = document.querySelector('select[name="age-verification-province"]');
  const ageVerificationStore    = document.querySelector('select[name="age-verification-store"]');
  const allStores    = document.querySelector('.amn-b-dropdown-content');
  const deliveryPickupOptions   = document.querySelector('.modal-popup__delivery-pickup-options');
  const deliveryPickupMessage   = document.querySelector('.modal-popup__delivery-pickup-message');
  const deliveryOption          = document.querySelector('input[name="delivery-pickup"][value="delivery"]');
  const pickupOption            = document.querySelector('input[name="delivery-pickup"][value="pickup"]');
  const deliveryButtonWrapper   = document.querySelector('.button--delivery-pickup-wrapper');
  const storeSelectionSection   = document.querySelector('.modal-popup__store-selection');
  const deliveryDisclaimer      = document.querySelector('.modal-popup__delivery-disclaimer');
  
  let ageVerified               = checkAgePopupCookie;
  let province                  = localStorage.getItem('global_province') ?? '';
  let selectedDeliveryPickup    = '';
  let currentAgeGateStore       = null;

  function updateCalgaryDisclaimer(store) {
    if (!deliveryDisclaimer) return;

    const isDeliverySelected =
      selectedDeliveryPickup === 'delivery' ||
      (deliveryOption && deliveryOption.checked) ||
      localStorage.getItem('age_verification_delivery') === 'true';
    const hubId = store && store.hub_id != null ? String(store.hub_id).trim().toLowerCase() : '';

    if (hubId === 'district' && isDeliverySelected) {
      deliveryDisclaimer.classList.remove('hidden');
    } else {
      deliveryDisclaimer.classList.add('hidden');
    }
  }

  // Global function to get user's current location
  function getCurrentUserLocation() {
    return new Promise((resolve, reject) => {
      // First check if we have stored location data
      const storedLat = localStorage.getItem('latitude_ai');
      const storedLon = localStorage.getItem('longitude_ai');
      
      if (storedLat && storedLon) {
        console.log('Using stored location:', storedLat, storedLon);
        resolve({
          latitude: parseFloat(storedLat),
          longitude: parseFloat(storedLon)
        });
        return;
      }
      
      // IPinfo is now PRIMARY method - try it first
      console.log('No stored location - trying IPinfo (PRIMARY METHOD)');
      getLocationFromIPinfo().then(resolve).catch(error => {
        console.log('IPinfo failed - trying geolocation fallback');
        // Fallback to geolocation if IPinfo fails
        if (!navigator.geolocation) {
          reject(new Error('Neither IPinfo nor geolocation available'));
          return;
        }

        // Set a timeout to reject the promise if geolocation takes too long
        const timeoutId = setTimeout(() => {
          console.log('Geolocation timeout - no location available');
          reject(new Error('Geolocation timeout'));
        }, 3000); // 3 second timeout for geolocation fallback

        navigator.geolocation.getCurrentPosition(
          (position) => {
            clearTimeout(timeoutId);
            console.log('Got geolocation (fallback):', position.coords.latitude, position.coords.longitude);
            // Store location for future use
            localStorage.setItem('latitude_ai', position.coords.latitude.toString());
            localStorage.setItem('longitude_ai', position.coords.longitude.toString());
            resolve({
              latitude: position.coords.latitude,
              longitude: position.coords.longitude
            });
          },
          (error) => {
            clearTimeout(timeoutId);
            console.error('Geolocation error (fallback):', error);
            reject(error);
          },
          {
            enableHighAccuracy: false, // Faster response
            timeout: 3000, // Match the timeout for consistency
            maximumAge: 300000 // 5 minutes
          }
        );
      });
    });
  }

  // Function to get location from IPinfo API (PRIMARY METHOD)
  function getLocationFromIPinfo() {
    return new Promise((resolve, reject) => {
      console.log('Getting location from IPinfo (PRIMARY METHOD)...');
      const ipinfoKey = 'fe81980d04a54c';
      
      fetch(`https://ipinfo.io/json?token=${ipinfoKey}`)
        .then(response => {
          if (!response.ok) {
            throw new Error(`IPinfo API error: ${response.status}`);
          }
          return response.json();
        })
        .then(data => {
          console.log('IPinfo response:', data);
          
          if (data.loc) {
            const [lat, lng] = data.loc.split(',').map(coord => parseFloat(coord.trim()));
            if (!isNaN(lat) && !isNaN(lng)) {
              const location = {
                latitude: lat,
                longitude: lng
              };
              // Store location for future use
              localStorage.setItem('latitude_ai', location.latitude.toString());
              localStorage.setItem('longitude_ai', location.longitude.toString());
              console.log('✅ Got location from IPinfo (PRIMARY):', location, 'City:', data.city, 'Region:', data.region);
              resolve(location);
              return;
            }
          }
          
          console.warn('❌ IPinfo location data invalid, rejecting');
          reject(new Error('IPinfo location data invalid'));
        })
        .catch(error => {
          console.error('❌ IPinfo API error:', error);
          reject(error);
        });
    });
  }

  function hideDeliveryPickupOptions() {
    if (deliveryPickupOptions) {
      deliveryPickupOptions.classList.add('hidden');
      selectedDeliveryPickup = '';
      // Clear delivery/pickup localStorage when hiding options
      localStorage.removeItem('age_verification_delivery');
      localStorage.removeItem('age_verification_pickup');
    }
  }

  function updateDeliveryPickupSelection() {
    if (deliveryOption && pickupOption) {
      deliveryOption.addEventListener('change', function() {
        if (this.checked) {
          selectedDeliveryPickup = 'delivery';
          localStorage.setItem('age_verification_delivery', 'true');
          localStorage.setItem('age_verification_pickup', 'false');
          console.log('Delivery selected for store:', storeId);
          updateCalgaryDisclaimer(currentAgeGateStore);
        }
      });

      pickupOption.addEventListener('change', function() {
        if (this.checked) {
          selectedDeliveryPickup = 'pickup';
          localStorage.setItem('age_verification_delivery', 'false');
          localStorage.setItem('age_verification_pickup', 'true');
          console.log('Pickup selected for store:', storeId);
          updateCalgaryDisclaimer(currentAgeGateStore);
        }
      });
    }
  }

  function showDeliveryPickupOptionsForStore(store) {
    if (!deliveryPickupOptions) return;

    currentAgeGateStore = store;

    const hasPickup = !!store.has_pickup;
    const hubId = store.hub_id != null ? String(store.hub_id).trim() : '';
    const hasHubId = hubId !== '';
    const isDistrictHub = hubId.toLowerCase() === 'district';
    const hasNormalDelivery = !!store.has_delivery;
    
    console.log('showDeliveryPickupOptionsForStore:', {
      store: store.title,
      hasPickup,
      hasNormalDelivery,
      hub_id: store.hub_id,
      hasHubId
    });
    
    // Reset selections
    selectedDeliveryPickup = '';
    if (deliveryOption) deliveryOption.checked = false;
    if (pickupOption) pickupOption.checked = false;

    updateCalgaryDisclaimer(store);
    
    // Reset delivery button text to default
    const deliveryLabel = deliveryOption?.nextElementSibling;
    if (deliveryLabel && !hasHubId) {
      deliveryLabel.innerHTML = `
        <svg width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 5H15C15.5523 5 16 5.44772 16 6V14H5C3.34315 14 2 12.6569 2 11V6C2 5.44772 2.44772 5 3 5Z" stroke="#E1251C" stroke-width="2" stroke-linejoin="round"/>
                <path d="M16 8H19.5L22 11V14H16V8Z" stroke="#E1251C" stroke-width="2" stroke-linejoin="round"/>
                <circle cx="6.5" cy="16.5" r="2.5" stroke="#E1251C" stroke-width="2"/>
                <circle cx="18.5" cy="16.5" r="2.5" stroke="#E1251C" stroke-width="2"/>
                <path d="M9 16.5H16" stroke="#E1251C" stroke-width="2" stroke-linecap="round"/>
              </svg>
        Delivery
      `;
    }

    // If hub is district, label delivery as Express Delivery
    if (deliveryLabel && isDistrictHub) {
      deliveryLabel.innerHTML = `
        <svg width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 5H15C15.5523 5 16 5.44772 16 6V14H5C3.34315 14 2 12.6569 2 11V6C2 5.44772 2.44772 5 3 5Z" stroke="#E1251C" stroke-width="2" stroke-linejoin="round"/>
                <path d="M16 8H19.5L22 11V14H16V8Z" stroke="#E1251C" stroke-width="2" stroke-linejoin="round"/>
                <circle cx="6.5" cy="16.5" r="2.5" stroke="#E1251C" stroke-width="2"/>
                <circle cx="18.5" cy="16.5" r="2.5" stroke="#E1251C" stroke-width="2"/>
                <path d="M9 16.5H16" stroke="#E1251C" stroke-width="2" stroke-linecap="round"/>
              </svg>
        Express Delivery
      `;
    }
    
    // Only check express delivery if store has hub_id (delivery capability)
    if (hasHubId) {
      // Show loading state
      showExpressDeliveryLoader();
      
      // Get customer location and check express delivery
      getCurrentUserLocation().then(location => {
        console.log('Checking express delivery for store:', store.title, 'hub_id:', store.hub_id);
        
        // Call express delivery API
        checkExpressDelivery(
          location.latitude,
          location.longitude,
          store.hub_id
        ).then(expressDeliveryData => {
          console.log('Express delivery API response:', expressDeliveryData);
          
          // Hide loading state
          hideExpressDeliveryLoader();
          
          if (expressDeliveryData && expressDeliveryData.is_express) {
            // Express delivery available - show delivery options
            if (deliveryPickupOptions) deliveryPickupOptions.classList.remove('hidden');
            
            // Show announcement bar for express delivery
            const announcementBar = document.querySelector('.announcement-bar-section');
            if (announcementBar) {
              announcementBar.classList.remove('hidden');
              console.log('Express delivery available - showing announcement bar');
            }
            
            // Update delivery button text to show "Express Delivery"
            const deliveryText = document.getElementById('delivery-text');
            if (deliveryText) {
              deliveryText.textContent = 'Express Delivery (35 min)';
            }
            
            if (hasPickup) {
              // Store has both delivery and pickup - show both radio buttons
              if (deliveryPickupMessage) deliveryPickupMessage.classList.add('hidden');
              if (deliveryButtonWrapper) deliveryButtonWrapper.classList.remove('hidden');
              console.log('Express delivery available - showing both delivery and pickup options');
            } else {
              // Store has only delivery - show only delivery option
              if (deliveryPickupMessage) deliveryPickupMessage.classList.add('hidden');
              if (deliveryButtonWrapper) deliveryButtonWrapper.classList.remove('hidden');
              if (deliveryOption) deliveryOption.checked = true;
              selectedDeliveryPickup = 'delivery';
              localStorage.setItem('age_verification_delivery', 'true');
              localStorage.setItem('age_verification_pickup', 'false');
              console.log('Express delivery available - auto-selecting delivery');
              updateCalgaryDisclaimer(store);
            }
          } else {
            // Express delivery not available - check if store has normal delivery
            if (hasNormalDelivery) {
              console.log('Express delivery not available, but normal delivery available for store:', store.title);
              
              // Show delivery/pickup options for normal delivery
              if (deliveryPickupOptions) deliveryPickupOptions.classList.remove('hidden');
              
              // Hide announcement bar for normal delivery
              const announcementBar = document.querySelector('.announcement-bar-section');
              if (announcementBar) {
                announcementBar.classList.add('hidden');
                console.log('Normal delivery only - hiding announcement bar');
              }
              
              // Update delivery button text to show "Delivery" (not Express)
              const deliveryText = document.getElementById('delivery-text');
              if (deliveryText) {
                deliveryText.textContent = 'Delivery';
              }
              
              if (hasPickup) {
                // Store has both normal delivery and pickup - show both radio buttons
                if (deliveryPickupMessage) deliveryPickupMessage.classList.add('hidden');
                if (deliveryButtonWrapper) deliveryButtonWrapper.classList.remove('hidden');
                console.log('Normal delivery available - showing both delivery and pickup options');
              } else {
                // Store has only normal delivery - show only delivery option
                if (deliveryPickupMessage) deliveryPickupMessage.classList.add('hidden');
                if (deliveryButtonWrapper) deliveryButtonWrapper.classList.remove('hidden');
              if (deliveryOption) deliveryOption.checked = true;
              selectedDeliveryPickup = 'delivery';
              localStorage.setItem('age_verification_delivery', 'true');
              localStorage.setItem('age_verification_pickup', 'false');
              console.log('Normal delivery available - auto-selecting delivery');
              updateCalgaryDisclaimer(store);
            }
          } else {
            // No delivery available at all - hide the entire section and announcement bar
            if (deliveryPickupOptions) deliveryPickupOptions.classList.add('hidden');
              
              // Hide announcement bar
              const announcementBar = document.querySelector('.announcement-bar-section');
              if (announcementBar) {
                announcementBar.classList.add('hidden');
                console.log('No delivery available - hiding announcement bar');
              }
              
              console.log('No delivery available - hiding delivery/pickup section');
            }
          }
        }).catch(error => {
          console.error('Error checking express delivery:', error);
          // Hide loading state and hide section on error
          hideExpressDeliveryLoader();
          if (deliveryPickupOptions) deliveryPickupOptions.classList.add('hidden');
          
          // Hide announcement bar on error
          const announcementBar = document.querySelector('.announcement-bar-section');
          if (announcementBar) {
            announcementBar.classList.add('hidden');
            console.log('Express delivery check failed - hiding announcement bar');
          }
          
          console.log('Express delivery check failed - hiding delivery/pickup section');
        });
      }).catch(error => {
        console.error('Error getting customer location:', error);
        // Hide loading state and hide section on error
        hideExpressDeliveryLoader();
        if (deliveryPickupOptions) deliveryPickupOptions.classList.add('hidden');
        
        // Hide announcement bar on location error
        const announcementBar = document.querySelector('.announcement-bar-section');
        if (announcementBar) {
          announcementBar.classList.add('hidden');
          console.log('Could not get customer location - hiding announcement bar');
        }
        
        console.log('Could not get customer location - hiding delivery/pickup section');
      });
      } else {
        // Store has no hub_id - check if it has normal delivery
        if (hasNormalDelivery) {
        console.log('Store has normal delivery (no hub_id) for store:', store.title);
        
        // Show delivery/pickup options for normal delivery
        if (deliveryPickupOptions) deliveryPickupOptions.classList.remove('hidden');
        
        // Hide announcement bar for normal delivery
        const announcementBar = document.querySelector('.announcement-bar-section');
        if (announcementBar) {
          announcementBar.classList.add('hidden');
          console.log('Normal delivery only - hiding announcement bar');
        }
        
        // Update delivery button text to show "Delivery" (not Express)
        const deliveryText = document.getElementById('delivery-text');
        if (deliveryText) {
          deliveryText.textContent = 'Delivery';
        }
        
        if (hasPickup) {
          // Store has both normal delivery and pickup - show both radio buttons
          if (deliveryPickupMessage) deliveryPickupMessage.classList.add('hidden');
          if (deliveryButtonWrapper) deliveryButtonWrapper.classList.remove('hidden');
          console.log('Normal delivery available - showing both delivery and pickup options');
        } else {
          // Store has only normal delivery - show only delivery option
          if (deliveryPickupMessage) deliveryPickupMessage.classList.add('hidden');
          if (deliveryButtonWrapper) deliveryButtonWrapper.classList.remove('hidden');
          if (deliveryOption) deliveryOption.checked = true;
          selectedDeliveryPickup = 'delivery';
          localStorage.setItem('age_verification_delivery', 'true');
          localStorage.setItem('age_verification_pickup', 'false');
          console.log('Normal delivery available - auto-selecting delivery');
          updateCalgaryDisclaimer(store);
        }
      } else {
        // Store has no delivery capability at all - hide the entire section
        if (deliveryPickupOptions) deliveryPickupOptions.classList.add('hidden');
        
        // Hide announcement bar when no delivery capability
        const announcementBar = document.querySelector('.announcement-bar-section');
        if (announcementBar) {
          announcementBar.classList.add('hidden');
          console.log('Store has no delivery capability - hiding announcement bar');
        }
        
        console.log('Store has no delivery capability - hiding delivery/pickup section');
      }
    }
  }

  // Show loading state for express delivery check
  function showExpressDeliveryLoader() {
    // Create loader if it doesn't exist
    let loader = document.querySelector('.express-delivery-loader');
    
    if (!loader) {
      loader = document.createElement('div');
      loader.className = 'express-delivery-loader';
      loader.innerHTML = `
        <div style="
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 20px;
          background-color: #f8f9fa;
          border-radius: 8px;
          margin: 10px 0;
        ">
          <div style="
            width: 20px;
            height: 20px;
            border: 2px solid #e3e3e3;
            border-top: 2px solid #E1251C;
            border-radius: 50%;
            animation: spin 1s linear infinite;
            margin-right: 10px;
          "></div>
          <span style="color: #666; font-size: 14px;">Checking delivery availability...</span>
        </div>
        <style>
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        </style>
      `;
    }
    
    // Hide delivery/pickup options and show loader
    if (deliveryPickupMessage) deliveryPickupMessage.classList.add('hidden');
    if (deliveryButtonWrapper) deliveryButtonWrapper.classList.add('hidden');
    
    // Insert loader before delivery/pickup options
    deliveryPickupOptions.insertBefore(loader, deliveryPickupMessage);
  }

  // Hide loading state for express delivery check
  function hideExpressDeliveryLoader() {
    const loader = document.querySelector('.express-delivery-loader');
    if (loader) {
      loader.remove();
    }
  }

  // Check express delivery availability
  async function checkExpressDelivery(lat, lng, hubId) {
    try {
      console.log('Checking express delivery for:', { lat, lng, hubId });
      
      // Test mode - bypass API for UI/UX testing
      const testMode = getTestMode();
      if (testMode.enabled) {
        console.log('🧪 TEST MODE: Using mock response instead of API call');
        return getMockExpressDeliveryResponse(testMode.scenario, hubId);
      }
      
      const response = await fetch('https://app.cannacabana.com/api/is-express-delivery', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          lat: lat.toString(),
          lng: lng.toString(),
          zone: hubId
        })
      });
      
      if (!response.ok) {
        throw new Error(`Express delivery API error: ${response.status}`);
      }
      
      const data = await response.json();
      console.log('Express delivery API response:', data);
      
      return data;
    } catch (error) {
      console.error('❌ Express delivery API error:', error);
      return null;
    }
  }

  // Get test mode configuration
  function getTestMode() {
    // Check URL parameters for test mode
    const urlParams = new URLSearchParams(window.location.search);
    const testMode = urlParams.get('test_express_delivery');
    
    if (testMode) {
      return {
        enabled: true,
        scenario: testMode // 'available', 'unavailable', 'error'
      };
    }
    
    // Check localStorage for test mode
    const storedTestMode = localStorage.getItem('test_express_delivery');
    if (storedTestMode) {
      return {
        enabled: true,
        scenario: storedTestMode
      };
    }
    
    return { enabled: false };
  }

  // Get mock response for testing
  function getMockExpressDeliveryResponse(scenario, hubId) {
    const mockResponses = {
      'available': {
        lat: 51.1530975,
        lng: -114.0669958,
        is_express: true,
        zone: hubId,
        delivery_type: "express"
      },
      'unavailable': {
        lat: 51.1530975,
        lng: -114.0669958,
        is_express: false,
        zone: hubId,
        delivery_type: "standard"
      },
      'error': null, // Simulate API error
      'slow': new Promise(resolve => {
        // Simulate slow API response (3 seconds)
        setTimeout(() => {
          resolve({
            lat: 51.1530975,
            lng: -114.0669958,
            is_express: true,
            zone: hubId,
            delivery_type: "express"
          });
        }, 3000);
      })
    };
    
    const response = mockResponses[scenario] || mockResponses['available'];
    console.log(`🧪 Mock response for scenario "${scenario}":`, response);
    
    return response;
  }

  // Global function to filter stores by method and location
  function filterStoresByMethodAndLocation(userLat, userLon, method = 'pickup', maxDistance = null) {
    if (!window.stores) return [];

    const allStores = Object.values(window.stores);
    
    return allStores
      .filter(store => {
        // Filter by method capability
        if (method === 'pickup') return store.has_pickup === true;
        if (method === 'delivery') {
          const hasHubId = store.hub_id && store.hub_id !== '';
          console.log(`Store ${store.title}: hub_id = ${store.hub_id}, eligible = ${hasHubId}`);
          return hasHubId;
        }
        return true; // Show all if no method specified
      })
      .filter(store => {
        // Ensure store has valid coordinates
        return store.address?.latitude && store.address?.longitude;
      })
      .map(store => {
        // Calculate distance from user to store
        const distance = getDistanceFromLatLonInKm(
          userLat, userLon, 
          store.address.latitude, 
          store.address.longitude
        );
        return { ...store, distance };
      })
      .filter(store => {
        // No distance restrictions - only filter by method capability
        return true;
      })
      .sort((a, b) => a.distance - b.distance); // Sort by distance
  }

  // Show test mode indicator
  function showTestModeIndicator() {
    const testMode = getTestMode();
    if (testMode.enabled) {
      console.log('🧪 TEST MODE ACTIVE:', testMode.scenario);
      
      // Create test mode indicator
      let indicator = document.querySelector('.test-mode-indicator');
      if (!indicator) {
        indicator = document.createElement('div');
        indicator.className = 'test-mode-indicator';
        indicator.style.cssText = `
          position: fixed;
          top: 10px;
          right: 10px;
          background: #ff6b35;
          color: white;
          padding: 8px 12px;
          border-radius: 4px;
          font-size: 12px;
          font-weight: bold;
          z-index: 9999;
          box-shadow: 0 2px 8px rgba(0,0,0,0.2);
        `;
        document.body.appendChild(indicator);
      }
      
      indicator.textContent = `🧪 TEST: ${testMode.scenario.toUpperCase()}`;
    }
  }

  function getStoreSelectData() {
    const provinceToStores = {};

    Object.entries(window.stores).forEach(([key, store]) => {
      const province = store.address.province;
      if (!provinceToStores[province]) {
        provinceToStores[province] = [];
      }

      provinceToStores[province].push({id: key, ...store});
    
    });

    while (ageVerificationProvince.options.length > 1) {
      ageVerificationProvince.remove(1);
    }
    
    Object.keys(provinceToStores).sort().forEach(province => {
      console.log("Province Option");
      const option       = document.createElement('option');
      option.value       = province;
      option.textContent = province;
      ageVerificationProvince.appendChild(option);
    });

    ageVerificationProvince.value = province;

    ageVerificationProvince.addEventListener('change', (event) => {
      province = event.target.value;
      populateStores(provinceToStores, province, storeId);

      if (province !== '') {
        document.querySelector('.modal-popup__province-select.hidden')?.classList.remove('hidden');
      } else {
        document.querySelector('.modal-popup__province-select.hidden')?.classList.add('hidden');
      }

      setCookie('global_province', province, 7);
      localStorage.setItem('global_province', province);
    });

    let closestStore = null;
    let minDistance  = Infinity;

    // Try to get user location with IPinfo fallback
    getCurrentUserLocation().then(location => {
      const userLatitude = location.latitude;
      const userLongitude = location.longitude;

      console.log('Got user location for store selection:', userLatitude, userLongitude);

      // Calculate distances for all stores (no filtering by delivery/pickup)
      Object.entries(provinceToStores).forEach(([province, stores]) => {
        stores.forEach(store => {
          const distance = getDistanceFromLatLonInKm(
            userLatitude, userLongitude, store.address.latitude, store.address.longitude
          );

          store.distance = distance;

          // Find closest store regardless of delivery/pickup capability
          if (distance < minDistance) {
            closestStore = store;
            minDistance  = distance;
          }
        });
      });

      if (closestStore !== null) {
        storeId = closestStore.store_id;
        console.log('Location-based: Closest store selected:', closestStore.title, 'Distance:', closestStore.distance.toFixed(2), 'km');
      } else {
        console.log('Location-based: No stores found');
      }

      if (province === '' && closestStore !== null) {
        ageVerificationProvince.value = closestStore.address.province;
        ageVerificationProvince.dispatchEvent(new Event('change', {'bubbles': true}));
      }

      if (province !== '') {
        ageVerificationProvince.dispatchEvent(new Event('change', {'bubbles': true}));
      }
    }).catch(error => {
      console.error('Error getting location (including IPinfo fallback):', error);

      if (province !== '') {
        ageVerificationProvince.dispatchEvent(new Event('change', {'bubbles': true}));
      }
    });

    ageVerificationStore.addEventListener('change', (event) => {
      storeId             = event.target.value;
      
      // Find the selected store from all stores (not just province-specific)
      const selectedStore = Object.values(window.stores).find(store => store.store_id === storeId);
     
      if (selectedStore) {
        setCookie('global_store_id', storeId, 7);
        setCookie('global_province', selectedStore.address.province, 7);
        localStorage.setItem('global_store_id', storeId);
        localStorage.setItem('global_province', selectedStore.address.province);
        
        localStorage.setItem('global_store', JSON.stringify(selectedStore));
        updateStoreHeader(selectedStore);
        updateCalgaryDisclaimer(selectedStore);
        
        // Show delivery/pickup options after store selection
        showDeliveryPickupOptionsForStore(selectedStore);
      }
    });
  }

  if (ageVerifiedButton) {
    if (!ageVerified || storeId === '') {
      getStoreSelectData();
      updateDeliveryPickupSelection();

      const errorMessage = document.querySelector('.modal-popup__age-error');
      errorMessage.classList.add('hidden');

      ageVerifiedButton.addEventListener('click', function (event) {
        event.preventDefault();

        if (!ageVerified || ageVerified === false) {
          errorMessage.classList.remove('hidden');
          return;
        }

        if (ageVerified === true && storeId !== '') {
          // Check if delivery/pickup selection is required
          if (deliveryPickupOptions && !deliveryPickupOptions.classList.contains('hidden')) {
            if (!selectedDeliveryPickup) {
              // Show error or prevent submission if no option is selected
              console.log('Please select delivery or pickup option');
              alert('Please select your preferred delivery method before continuing.');
              return;
            }
          }

          let ageVerificationPopup = document.querySelector('[data-popup-type="age-verification"]');
          let showAgainAgePopup    = ageVerificationPopup.dataset.popupDelayDays;
          ageVerificationPopup.classList.remove('active');
          setCookie('age-verification', true, showAgainAgePopup);
          localStorage.setItem('global_store_id', storeId);
          localStorage.setItem('global_province', province);
          localStorage.setItem('global_age', ageVerified);
          
          // Save the delivery/pickup selection with unique variable names
          if (selectedDeliveryPickup === 'delivery') {
            localStorage.setItem('age_verification_delivery', 'true');
            localStorage.setItem('age_verification_pickup', 'false');
          } else {
            localStorage.setItem('age_verification_delivery', 'false');
            localStorage.setItem('age_verification_pickup', 'true');
          }
          
          document.querySelector('.theme-modal-popup__overlay').classList.remove('active');
          document.querySelector('body').classList.remove('overflow-hidden');

          clearCart().then(() => {
            const currentUrl = new URL(window.location.href);
            currentUrl.searchParams.set('sID', storeId);
            console.log(currentUrl,"currentUrl");
            window.location.href = currentUrl.toString();
          });
        }
      });

      legalAgeInput.forEach((radio) => {
        radio.addEventListener('change', function (event) {
          ageVerified = JSON.parse(event.target.value);
          if (ageVerified === true) {
            errorMessage.classList.add('hidden');
          }

          ageVerifiedButton.classList.remove('disabled');
        });
      });
    } else {
      ageVerifiedButton.addEventListener('click', function (event) {
        event.preventDefault();

        clearCart().then(() => {
          const currentUrl = new URL(window.location.href);
          currentUrl.searchParams.set('sID', storeId);
          console.log(currentUrl,"currentUrl");
          window.location.href = currentUrl.toString();
        });
      });
    }
  }

  const openLocationModalButton = document.querySelector('.header__location-data--mobile');

  // Check if event listener has already been added to prevent duplicates
  if (openLocationModalButton && !openLocationModalButton.hasAttribute('data-event-listener-added')) {
    openLocationModalButton.setAttribute('data-event-listener-added', 'true');
    
    openLocationModalButton.addEventListener('click', function () {
      console.log("clicked");
        const storeUpdatePopup = document.querySelector('[data-popup-type="store-update"]');
        const locationModalOpened = storeUpdatePopup.classList.contains('active');
        console.log(locationModalOpened,"locationModalOpened")
        if(!locationModalOpened){
          storeUpdatePopup.classList.add('active');
          document.querySelector('body').classList.add('locator-opened');
          document.querySelector('.announcement-bar').classList.add('hidden');
          document.querySelector('.header__location-data--mobile .js-header-store-name').classList.add('hidden');
          document.querySelector('.header__location-data--mobile .js-header-street').classList.add('hidden');
          document.querySelector('.js-header-store-name-mobile').classList.remove('hidden');
          // Don't call getStoreSelectData() - let store-update.js handle its own initialization
        }else {
          storeUpdatePopup.classList.remove('active');
          document.querySelector('body').classList.remove('locator-opened');
          document.querySelector('.announcement-bar').classList.remove('hidden');
          document.querySelector('.header__location-data--desktop .js-header-store-name').classList.remove('hidden');
          document.querySelector('.header__location-data--desktop .js-header-street').classList.remove('hidden');
          document.querySelector('.js-header-store-name-desktop').classList.add('hidden');
        }
      
    });
  }

  const openLocationModalButtonDesktop = document.querySelector('.header__location-data--desktop');

  // Check if event listener has already been added to prevent duplicates
  if (openLocationModalButtonDesktop && !openLocationModalButtonDesktop.hasAttribute('data-event-listener-added')) {
    openLocationModalButtonDesktop.setAttribute('data-event-listener-added', 'true');
    
    openLocationModalButtonDesktop.addEventListener('click', function () {
      console.log("clicked");
        const storeUpdatePopup = document.querySelector('[data-popup-type="store-update"]');
        const locationModalOpened = storeUpdatePopup.classList.contains('active');
        console.log(locationModalOpened,"locationModalOpened")
        if(!locationModalOpened){
          storeUpdatePopup.classList.add('active');
          document.querySelector('body').classList.add('locator-opened');
          // document.querySelector('.announcement-bar').classList.add('hidden');
          document.querySelector('.header__location-data--desktop .js-header-store-name').classList.add('hidden');
          document.querySelector('.header__location-data--desktop .js-header-street').classList.add('hidden');
          document.querySelector('.js-header-store-name-desktop').classList.remove('hidden');
          // Don't call getStoreSelectData() - let store-update.js handle its own initialization
        }else {
          storeUpdatePopup.classList.remove('active');
          document.querySelector('body').classList.remove('locator-opened');
          document.querySelector('.announcement-bar').classList.remove('hidden');
          document.querySelector('.header__location-data--desktop .js-header-store-name').classList.remove('hidden');
          document.querySelector('.header__location-data--desktop .js-header-street').classList.remove('hidden');
          document.querySelector('.js-header-store-name-desktop').classList.add('hidden');
        }
      
    });
  }

  document.addEventListener('click', function (event) {
    const storeUpdatePopup = document.querySelector('[data-popup-type="store-update"]');
    const triggerButton = document.querySelector('.header__location-data--desktop');
    const triggerButtonMobile = document.querySelector('.header__location-data--mobile');
  
    if (!storeUpdatePopup) return;
    if (!storeUpdatePopup.classList.contains('active')) return;
  
    const clickedInsideModal = storeUpdatePopup.contains(event.target);
    const clickedTriggerButton = triggerButton && (triggerButton === event.target || triggerButton.contains(event.target));
    const clickedTriggerButtonMobile = triggerButtonMobile && (triggerButtonMobile === event.target || triggerButtonMobile.contains(event.target));
    if (!clickedInsideModal && !clickedTriggerButton && !clickedTriggerButtonMobile) {
      storeUpdatePopup.classList.remove('active');
      document.querySelector('body').classList.remove('locator-opened');
      document.querySelector('.header__location-data--desktop .js-header-store-name').classList.remove('hidden');
      document.querySelector('.header__location-data--desktop .js-header-street').classList.remove('hidden');
      document.querySelector('.js-header-store-name-desktop').classList.add('hidden');
    }
  });

  // document.addEventListener('click', function (event) {
  //   const storeUpdatePopup = document.querySelector('[data-popup-type="store-update"]');
  //   const locationModalOpened = storeUpdatePopup.classList.contains('active');
  //   if (!storeUpdatePopup) return;
  //   if (!locationModalOpened) return;
  
  //   if (!storeUpdatePopup.contains(event.target)) {
  //     storeUpdatePopup.classList.remove('active');
  //   }
  // });
  // const openModalButton = document.querySelectorAll('.js-header-location-data.header__location-data');

  // openModalButton.forEach(button => {
  //   button.addEventListener('click', function () {
  //       const ageVerificationPopup = document.querySelector('[data-popup-type="age-verification"]');
  //       ageVerificationPopup.classList.add('active');
  //       document.querySelector('body').classList.add('overflow-hidden');
  //       document.querySelector('.theme-modal-popup__overlay').classList.add('active');
  
  //       const legalAgeConsent        = document.querySelector('.modal-popup__legal-age-consent');
  //       const legalAgeConsentMessage = document.querySelector('.modal-popup__legal-age-consent-message');
  
  //       if (legalAgeConsent) {
  //         legalAgeConsent.classList.add('hidden');
  //         legalAgeConsentMessage.classList.remove('hidden');
  //         ageVerifiedButton.classList.remove('disabled');
  //       }

  //     getStoreSelectData();
  //   });
  // });

  function getStoreFulfillmentStatus(store) {
    const pickup = !!store.has_pickup;
    const delivery = !!store.has_delivery;
    const hasHubId = store.hub_id && store.hub_id !== '';

    let label_left;
    let label_right;
    if (pickup && delivery) {
      label_left = "Pickup";
      // Check if store has express delivery capability
      if (hasHubId) {
        label_right = "Express Delivery";
      } else {
        label_right = "Delivery";
      }
    } else if (pickup && !delivery) {
      label_left = "Pickup";
    }
    else if (delivery && !pickup) {
      // Store has only delivery
      if (hasHubId) {
        label_right = "Express Delivery";
      } else {
        label_right = "Delivery";
      }
    }
    
    return {  label_left, label_right };
  }

  function getStoreTimeZone(store) {
    const province = store && store.address ? store.address.province : '';
    const map = {
      'British Columbia': 'America/Vancouver',
      'Alberta': 'America/Edmonton',
      'Saskatchewan': 'America/Regina',
      'Manitoba': 'America/Winnipeg',
      'Ontario': 'America/Toronto',
      'Quebec': 'America/Toronto',
      'New Brunswick': 'America/Moncton',
      'Nova Scotia': 'America/Halifax',
      'Prince Edward Island': 'America/Halifax',
      'Newfoundland and Labrador': 'America/St_Johns',
      'Yukon': 'America/Whitehorse',
      'Northwest Territories': 'America/Edmonton',
      'Nunavut': 'America/Iqaluit',
    };
    return map[province] || 'America/Toronto';
  }

  function getStoreLocalDateParts(store) {
    const timeZone = getStoreTimeZone(store);
    const parts = new Intl.DateTimeFormat('en-CA', {
      timeZone,
      weekday: 'short',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    }).formatToParts(new Date());
    const lookup = {};
    parts.forEach((part) => {
      lookup[part.type] = part.value;
    });
    const weekdayMap = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
    return {
      day: weekdayMap[lookup.weekday],
      time: `${lookup.hour}${lookup.minute}`,
    };
  }

  function isStoreOpen(store) {
    if (!store.hours_periods || !Array.isArray(store.hours_periods)) return false;

    const { day, time: currentTime } = getStoreLocalDateParts(store);

    // Find today's hours
    const todayHours = store.hours_periods.find(h => h.open.day === day);
    if (!todayHours) return false;

    const openTime = todayHours.open.time;
    const closeTime = todayHours.close.time;

    // Handle overnight case (e.g., open 10:00, close 02:00 next day)
    if (closeTime < openTime) {
      return (currentTime >= openTime || currentTime <= closeTime);
    }

    return currentTime >= openTime && currentTime <= closeTime;
  }

  function updateStoreHeader(store) {
    console.log('🔄 popup-b.js: updateStoreHeader called with store:', store);
    console.log('🔄 popup-b.js: Script loaded and function executing');
    
    // Check if store update modal is active - if so, let store-update.js handle the header
    const storeUpdateModal = document.querySelector('[data-popup-type="store-update"]');
    if (storeUpdateModal && storeUpdateModal.classList.contains('active')) {
      console.log('🚫 popup-b.js: Store update modal is active, skipping header update to avoid conflict');
      return;
    }
    
    // Check if this is being called from store-update.js (which now handles its own header updates)
    const stackTrace = new Error().stack;
    if (stackTrace && stackTrace.includes('store-update.js')) {
      console.log('🚫 popup-b.js: Called from store-update.js, skipping to avoid conflict');
      return;
    }
    
    // Additional check: Skip if store has normal delivery (no hub_id) and delivery is selected
    const isDeliverySelected = localStorage.getItem('age_verification_delivery') === 'true';
    const hasHubId = store.hub_id && store.hub_id !== '';
    const hasNormalDelivery = store.has_delivery === true;
    
    if (isDeliverySelected && !hasHubId && hasNormalDelivery) {
      console.log('🚫 popup-b.js: Store has normal delivery only, letting store-update.js handle header');
      return;
    }
    
    const status_ai = isStoreOpen(store) ? "Open" : "Closed";
    const fullfill_s = getStoreFulfillmentStatus(store);
    localStorage.setItem('global_handle',store.handle);
    if(fullfill_s){localStorage.setItem('global_store_pickup', fullfill_s.label_left);localStorage.setItem('global_store_delivery', fullfill_s.label_right);}
    if(status_ai){localStorage.setItem('global_store_status', status_ai);}
    
    if (store.address && store.address.city && store.address.street1) {
      console.log('📍 Updating header with store info:', {
        city: store.address.city,
        street: store.address.street1
      });
      
      // Try to update header elements with retry mechanism
      const updateHeaderElements = () => {
        const storeNameElements = document.querySelectorAll('.js-header-store-name');
        const storeAddressElements = document.querySelectorAll('.js-header-street');

        console.log('🔍 Found store name elements:', storeNameElements.length);
        console.log('🔍 Found store address elements:', storeAddressElements.length);

        if (storeNameElements.length === 0 || storeAddressElements.length === 0) {
          console.log('⏳ Header elements not found, retrying in 100ms...');
          setTimeout(updateHeaderElements, 100);
          return;
        }

        if (store.distance) {
          localStorage.setItem('global_store_distance', store.distance);
        }

        // Get fulfillment method from localStorage - check both delivery and pickup flags
        const isDeliverySelected = localStorage.getItem('age_verification_delivery') === 'true';
        const isPickupSelected = localStorage.getItem('age_verification_pickup') === 'true';
        
        // Determine delivery method based on what's actually selected
        let deliveryMethod = 'Pickup'; // default
        if (isDeliverySelected && !isPickupSelected) {
          // Check if store has express delivery capability
          const hasHubId = store.hub_id && store.hub_id !== '';
          if (hasHubId) {
            deliveryMethod = 'Express Delivery';
          } else {
            deliveryMethod = 'Delivery';
          }
        } else if (isPickupSelected && !isDeliverySelected) {
          deliveryMethod = 'Pickup';
        } else {
          // If both are selected or neither is selected, check the store's capabilities
          const hasHubId = store.hub_id && store.hub_id !== '';
          if (hasHubId && isDeliverySelected) {
            deliveryMethod = 'Express Delivery';
          } else if (isDeliverySelected) {
            deliveryMethod = 'Delivery';
          } else {
            deliveryMethod = 'Pickup';
          }
        }
        
        // Update store name elements with fulfillment method
        storeNameElements.forEach((element, index) => {
          console.log(`📝 Updating store name element ${index}:`, element);
          element.textContent = `${deliveryMethod} | ${store.address.city}`;
        });

        // Update store address elements
        storeAddressElements.forEach((element, index) => {
          console.log(`📝 Updating store address element ${index}:`, element);
          element.textContent = store.address.street1;
        });
        
        console.log('✅ popup-b.js: Header update completed');
      };

      // Start the update process
      updateHeaderElements();
    } else {
      console.warn('⚠️ Store address data incomplete:', store.address);
    }
  }

  async function clearCart() {
    fetch(window.Shopify.routes.root + 'cart/clear.js', {
      method : 'POST',
      headers: {
        'Content-Type'    : 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(response => {
        if (response.ok) {
          return response.json();
        }
        throw new Error('Network response was not ok.');
      })
      .then(data => {
        //console.log('Cart cleared:', data);
      })
      .catch(error => {
        console.error('There was a problem with the fetch operation:', error);
      });
  }

  function setHeaderData() {
    storeId  = localStorage.getItem('global_store_id') ?? '';
    province = localStorage.getItem('global_province') ?? '';

    if (storeId && province && window.stores) {
      const provinceToStores = {};

      Object.entries(window.stores).forEach(([key, store]) => {
        const province = store.address.province;
        if (!provinceToStores[province]) {
          provinceToStores[province] = [];
        }

        provinceToStores[province].push({id: key, ...store});
      });

      const selectedStore = provinceToStores[province].find(store => store.store_id === storeId);
      if (selectedStore) {
        updateStoreHeader(selectedStore);
      }
    }
  }

  setHeaderData();

  // Initialize test mode indicator
  showTestModeIndicator();

  // Function to refresh header display when delivery method changes
  function refreshHeaderDisplay() {
    const globalStore = localStorage.getItem('global_store');
    if (globalStore) {
      try {
        const store = JSON.parse(globalStore);
        updateStoreHeader(store);
      } catch (e) {
        console.error('Error parsing global_store:', e);
      }
    }
  }

  // Listen for delivery/pickup changes
  document.addEventListener('change', function(event) {
    if (event.target.name === 'delivery-pickup') {
      console.log('🔄 Delivery method changed, refreshing header...');
      setTimeout(refreshHeaderDisplay, 100); // Small delay to ensure localStorage is updated
    }
  });

  let popupClose = document.querySelectorAll('.btn-modal-popup__trigger');
  popupClose.forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      let modalId = this.getAttribute('data-modal-id');
      const modal = document.querySelector('.theme-modal-popup[data-popup-type="' + modalId + '"]');
      
      if (modal) {
        modal.classList.remove('active');
        document.querySelector('.theme-modal-popup__overlay').classList.remove('active');
        document.querySelector('body').classList.remove('overflow-hidden');
        
        // Handle specific modal types
        if (modalId == 'newsletter') {
          let showAgainPopup = modal.dataset.popupDelayDays;
          setCookie('newsletter-popup', true, showAgainPopup);
        } else if (modalId == 'store-update') {
          // Handle store-update modal specific cleanup
          document.querySelector('body').classList.remove('locator-opened');
          document.querySelector('.announcement-bar').classList.remove('hidden');
          
          // Restore header elements
          const headerStoreName = document.querySelector('.header__location-data--desktop .js-header-store-name');
          const headerStreet = document.querySelector('.header__location-data--desktop .js-header-street');
          const headerStoreNameMobile = document.querySelector('.js-header-store-name-desktop');
          
          if (headerStoreName) headerStoreName.classList.remove('hidden');
          if (headerStreet) headerStreet.classList.remove('hidden');
          if (headerStoreNameMobile) headerStoreNameMobile.classList.add('hidden');
          
          console.log('✅ Store update modal closed via close button');
        }
      }
    });
  });

  // Global function for store-update.js to call
  window.updateStoreHeaderFromModal = function(store) {
    console.log('🔄 popup-b.js: updateStoreHeaderFromModal called from store-update.js');
    console.log('🔄 popup-b.js: Global function is available and executing');
    
    // Check if store has normal delivery (no hub_id) and delivery is selected
    const isDeliverySelected = localStorage.getItem('age_verification_delivery') === 'true';
    const hasHubId = store.hub_id && store.hub_id !== '';
    const hasNormalDelivery = store.has_delivery === true;
    
    if (isDeliverySelected && !hasHubId && hasNormalDelivery) {
      console.log('🚫 popup-b.js: Store has normal delivery only, skipping header update to let store-update.js handle it');
      return;
    }
    
    // Bypass conflict check since this is called specifically from store-update.js
    const status_ai = isStoreOpen(store) ? "Open" : "Closed";
    const fullfill_s = getStoreFulfillmentStatus(store);
    localStorage.setItem('global_handle',store.handle);
    if(fullfill_s){localStorage.setItem('global_store_pickup', fullfill_s.label_left);localStorage.setItem('global_store_delivery', fullfill_s.label_right);}
    if(status_ai){localStorage.setItem('global_store_status', status_ai);}
    
    if (store.address && store.address.city && store.address.street1) {
      const storeNameElements = document.querySelectorAll('.js-header-store-name');
      const storeAddressElements = document.querySelectorAll('.js-header-street');
      if (store.distance) {
        localStorage.setItem('global_store_distance', store.distance);
      }

      // Get fulfillment method from localStorage - check both delivery and pickup flags
      const isDeliverySelected = localStorage.getItem('age_verification_delivery') === 'true';
      const isPickupSelected = localStorage.getItem('age_verification_pickup') === 'true';
      
      // Determine delivery method based on what's actually selected
      let deliveryMethod = 'Pickup'; // default
      if (isDeliverySelected && !isPickupSelected) {
        // Check if store has express delivery capability
        const hasHubId = store.hub_id && store.hub_id !== '';
        if (hasHubId) {
          deliveryMethod = 'Express Delivery';
        } else {
          deliveryMethod = 'Delivery';
        }
      } else if (isPickupSelected && !isDeliverySelected) {
        deliveryMethod = 'Pickup';
      } else {
        // If both are selected or neither is selected, check the store's capabilities
        const hasHubId = store.hub_id && store.hub_id !== '';
        if (hasHubId && isDeliverySelected) {
          deliveryMethod = 'Express Delivery';
        } else if (isDeliverySelected) {
          deliveryMethod = 'Delivery';
        } else {
          deliveryMethod = 'Pickup';
        }
      }
      
      console.log('🚚 popup-b.js: Delivery method:', deliveryMethod, 'delivery:', isDeliverySelected, 'pickup:', isPickupSelected);

      storeNameElements.forEach(element => {
        element.textContent = `${deliveryMethod} | ${store.address.city}`;
        console.log(`📝 popup-b.js: Set header text to: "${deliveryMethod} | ${store.address.city}"`);
      });

      storeAddressElements.forEach(element => {
        element.textContent = store.address.street1;
        console.log(`📝 popup-b.js: Set header address to: "${store.address.street1}"`);
      });
      
      console.log('✅ popup-b.js: Header update completed from modal');
    }
  };
})();
